import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import LoginBackground from './components/LoginBackground';
import SecurityBadge from './components/SecurityBadge';

const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate('/ai-agents-dashboard');
    }

    // Set page title
    document.title = 'Anmelden - Vierdimensional';
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background relative flex items-center justify-center p-4">
      {/* Background Elements */}
      <LoginBackground />
      {/* Main Content */}
      <div className="relative z-10 w-full max-w-md">
        {/* Login Card */}
        <div className="bg-card border border-border rounded-xl shadow-lg p-8 animate-fade-in">
          {/* Header */}
          <LoginHeader />
          
          {/* Login Form */}
          <LoginForm />
          
          {/* Security Badge */}
          <SecurityBadge />
        </div>
        
        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} Vierdimensional. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;